// extracted by mini-css-extract-plugin
export default {"cls1":"gIhgMhIdWbvh15Elw_UV","cls2":"yDVZcLN5p4ugBYRONtfr gIhgMhIdWbvh15Elw_UV"};